module.exports = __webpack_public_path__ + "static/media/uthealth-departmental-office-logo-uth.57739cdc.svg";